
// actions
export const INITIALIZE = 'INITIALIZE'
export const CLEAR = 'CLEAR'
// mutations
export const CLEAR_ITEMS = 'CLEAR_ITEMS'
export const ADD_ITEM = 'ADD_ITEM'
export const REMOVE_ITEM = 'REMOVE_ITEM'
export const ITEM_AMOUNT_PLUS = 'ITEM_AMOUNT_PLUS'
export const ITEM_AMOUNT_MINUS = 'ITEM_AMOUNT_MINUS'
export const UPDATE_STORE_ID = 'UPDATE_STORE_ID'
export const UPDATE_MENU_ID = 'UPDATE_MENU_ID'
export const UPDATE_CART_TYPE = 'UPDATE_CART_TYPE'
export const UPDATE_CART_TABLE_NO = 'UPDATE_CART_TABLE_NO'
export const UPDATE_CART_NOTE = 'UPDATE_CART_NOTE'
export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD'
// getters
export const ORDER_DATA = 'ORDER_DATA'
export const CART_ITEMS = 'CART_ITEMS'
export const CART_ITEM_COUNT = 'CART_ITEM_COUNT'
export const CART_STORE_ID = 'CART_STORE_ID'
export const CART_TYPE = 'CART_TYPE'
export const CART_TABLE_NO = 'CART_TABLE_NO'
export const CART_NOTE = 'CART_NOTE'
export const PAYMENT_METHOD = 'PAYMENT_METHOD'
export const CART_PRICE = 'CART_PRICE'

const state = {
  items: [],
  storeid: null,
  type: null,
  tableNo: '',
  note: '',
  paymentMethod: 'Cash',
  price: 0
}
const methods = {
  computePrice () {
    let _price = 0
    for (let item in state.items) {
      _price += state.items[item].price
    }
    return _price
  }
}
const actions = {
  [INITIALIZE] ({ commit }, data) {
    commit(UPDATE_STORE_ID, data.storeid)
    commit(UPDATE_MENU_ID, data.menuid)
    commit(UPDATE_CART_TYPE, data.type)
    commit(UPDATE_CART_TABLE_NO, data.tableNo)
    commit(UPDATE_PAYMENT_METHOD, 'Cash')
  },
  [CLEAR] ({ commit }) {
    commit(CLEAR_ITEMS)
    commit(UPDATE_STORE_ID, null)
    commit(UPDATE_MENU_ID, null)
    commit(UPDATE_CART_TYPE, '')
    commit(UPDATE_CART_TABLE_NO, '')
    commit(UPDATE_CART_NOTE, '')
    commit(UPDATE_PAYMENT_METHOD, 'Cash')
  }
}
const mutations = {
  [CLEAR_ITEMS] (state) {
    state.items = []
    state.price = 0
  },
  [ADD_ITEM] (state, item) {
    if (item) {
      if (!state.items) {
        state.items = []
      }
      state.items.push(item)
      state.price = methods.computePrice()
    }
  },
  [REMOVE_ITEM] (state, index) {
    if (index >= 0) {
      state.items.splice(index, 1)
      state.price = methods.computePrice()
    }
  },
  [ITEM_AMOUNT_PLUS] (state, index) {
    if (index >= 0) {
      let _item = state.items[index]
      if (_item.amount) {
        _item.price = (_item.originPrice + (_item.custPrice || 0)) * ++_item.amount
        state.price = methods.computePrice()
      }
    }
  },
  [ITEM_AMOUNT_MINUS] (state, index) {
    if (index >= 0) {
      let _item = state.items[index]
      if (_item.amount > 1) {
        _item.price = (_item.originPrice + (_item.custPrice || 0)) * --_item.amount
      } else {
        state.items.splice(index, 1)
      }
      state.price = methods.computePrice()
    }
  },
  [UPDATE_STORE_ID] (state, data) {
    state.storeid = data
  },
  [UPDATE_MENU_ID] (state, data) {
    state.menuId = data
  },
  [UPDATE_CART_TYPE] (state, data) {
    state.type = data
  },
  [UPDATE_CART_TABLE_NO] (state, data) {
    state.tableNo = data
  },
  [UPDATE_CART_NOTE] (state, data) {
    state.note = data
  },
  [UPDATE_PAYMENT_METHOD] (state, data) {
    state.paymentMethod = data
  }
}

const getters = {
  [ORDER_DATA] (state) {
    return {
      menuId: state.menuId,
      note: state.note || '',
      tableNo: state.tableNo || '',
      type: state.type,
      paymentMethod: state.paymentMethod,
      Details: state.items.map(function (item) {
        return {
          productId: item.id,
          productStyleId: item.productStyleId,
          amount: item.amount,
          note: item.note,
          cust: item.custs,
          promotion: item.promotion
        }
      })
    }
  },
  [CART_ITEMS] (state) {
    return state.items
  }, // 取得已點餐點
  [CART_ITEM_COUNT] (state) {
    return state.items.length
  }, // 取得已點餐點數量
  [CART_STORE_ID] (state) {
    return state.storeid
  }, // 取得店家
  [CART_TYPE] (state) {
    return state.type
  }, // 取得訂單類型
  [CART_TABLE_NO] (state) {
    return state.tableNo
  }, // 取得桌號
  [CART_NOTE] (state) {
    return state.note
  }, // 取得備註
  [PAYMENT_METHOD] (state) {
    return state.paymentMethod
  }, // 取得付款方式
  [CART_PRICE] (state) {
    return state.price
  } // 取得總價
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true // 多模組的時候，當有相同名稱的變數或方法才能區隔開
}



// WEBPACK FOOTER //
// ./src/store/modules/shopcart.js